import { PayloadAction } from '@reduxjs/toolkit';
import { searchRequest } from 'core/services/product';
import { listRequest } from 'core/services/admin';
import { ISearchReducer, ISearchSelection, selectSearchResult, updateSearch } from 'core/slices/search';
import { all, call, fork, put, select, debounce, takeLatest } from 'redux-saga/effects';
import { RootState } from 'types';
import { SearchType } from 'types/domain/search';
import { selectSession } from 'core/selectors/product/session';
import { ISessionReducer } from 'core/slices/session';
import { startModule } from './module/start';
import { EntityTypes } from 'constants/entities';

function* updateSearchSaga(action) {
  const search: ISearchReducer = yield select((state: RootState) => state.core.search);
  const session: ISessionReducer = yield select(selectSession);

  if (search.term?.length && search.searchType) {
    // Use listRequest for ORG_USER search type
    if (search.searchType === SearchType.ORG_USER) {
      // Get componentId from action payload or use default
      const componentId = action.payload?.componentId || 'learners-page';
      const paginationState = search.components[componentId] || { pageSize: 10 };

      yield put(
        listRequest({
          type: EntityTypes.ORG_USER,
          filter: {
            search: search.term,
          },
          pagerInfo: {
            page: 0,
            pageCount: paginationState.pageSize,
          },
          componentId,
        }),
      );
    }
    // if (search.searchType === SearchType.COURSE_PROGRESS) {
    //   // Get componentId from action payload or use default
    //   const componentId = action.payload?.componentId || 'module-share';
    //   const paginationState = search.components[componentId] || { pageSize: 10 };
    //   const courseId = yield select((state: RootState) => state.state[EntityTypes.COURSE]);

    //   yield put(
    //     listRequest({
    //       type: EntityTypes.COURSE_PROGRESS,
    //       filter: {
    //         search: search.term,
    //       },
    //       parentEntityId: courseId,
    //       pagerInfo: {
    //         page: 0,
    //         pageCount: paginationState.pageSize,
    //       },
    //       componentId,
    //     }),
    //   );
    // }
    // Use searchRequest for other search types
    else if ([SearchType.LEARNER, SearchType.MODULE].includes(search.searchType)) {
      const componentId = action.payload?.componentId;
      yield put(
        searchRequest({
          term: search.term,
          filter: search.filter,
          searchType: search.searchType,
          sessionId: session.session?.id,
          pagerInfo: { page: 0 },
          componentId,
        }),
      );
    }
  }
}

function* selectSearchSaga(action: PayloadAction<ISearchSelection>) {
  const search: ISearchReducer = yield select((state: RootState) => state.core.search);
  if (action.payload.moduleId && search.searchType === SearchType.LEARNER) {
    yield startModule(action.payload.moduleId, action.payload.actionId, true);
  }
}

function* watchSelectSearch() {
  yield takeLatest(selectSearchResult, selectSearchSaga);
}

function* watchSearch() {
  yield takeLatest(updateSearch, updateSearchSaga);
}

export default function* searchSaga() {
  yield all([fork(watchSearch), fork(watchSelectSearch)]);
}
